import * as React from "react";
import { PanelFooter } from "../react/panel-footer.jsx";
import { PanelHeader } from "../react/panel-header.jsx";
import { VisitHelpCenter } from "../react/visit-help-center.jsx";
import { EgenciaProvider, UitkSpacing } from "@egencia/uitk-react";
import { PanelArticlesList } from "../react/panel-articles-list";
import { logMetadata, searchFaq } from "../common/searchFaq";
import { NoSearchResults } from "../react/no-search-results";
import { LLMCard } from "../react/llm-card";
import * as ReactDOM from "react-dom";

EG.HelpCenter.Presenters.PanelIndex = function () {
    //----- Initialize -----//
    uitk.analytics.set('pageName', EG.pageName);
    uitk.analytics.send();
    
    const footerContainer= ReactDOM.createRoot(document.querySelector("#panel-footer-container"));
    const faqsContainer = ReactDOM.createRoot(document.querySelector("#panel-faqs"));
    const headerContainer = ReactDOM.createRoot(document.querySelector("#panel-header-container"));
    const panelViewName = "DefaultPage";
    const {anonymousUser} = EG.bootstrapped;

    const defaultArticleGroups = [
        { icon: 'warning', type: 'Alert', title: uitk.i18n.msg('panel_alert_section_title'), articles: EG.bootstrapped.alerts },
        { title: uitk.i18n.msg('panel_suggested_section_title'), type: 'Faq', articles: EG.bootstrapped.suggestedFaqs },
    ]
    
    function outageBannerEnabled() {
        if (EG.bootstrapped && EG.bootstrapped.alertMessaging) {
            return EG.bootstrapped.alertMessaging.beforeOutage || EG.bootstrapped.alertMessaging.duringOutage;
        }
    }

    function handleFaqSearch(value) {
        if (value.length) {
            const searchResults = searchFaq.search(value, EG.bootstrapped.faqs);
            const highlightedSearchResults = searchFaq.highlightArticles(searchResults, value);
            
            const searchAlertResults = searchFaq.search(value, EG.bootstrapped.alerts);
            const highlightedAlertSearchResults = searchFaq.highlightArticles(searchAlertResults, value);

            logMetadata(searchFaq, value, searchResults.length + searchAlertResults.length);
            
            renderArticleList([
                { icon: 'warning', type: 'Alert', title: uitk.i18n.msg('panel_header_section_title_search_result'), articles: highlightedAlertSearchResults },
                { type: 'Faq', articles: highlightedSearchResults },
            ]);
        } else {
            renderArticleList(defaultArticleGroups)
        }
    }
    
    const headerTitle = uitk.i18n.msg("panel_header_section_title_egencia_help");
    
    headerContainer.render(
        <EgenciaProvider>
            <PanelHeader title={headerTitle} hasSearch={true} hasBackBtn={false} panelViewName={panelViewName} onFaqSearch={handleFaqSearch} />
        </EgenciaProvider>
    );

    footerContainer.render(
        <EgenciaProvider>
            <PanelFooter panelViewName={panelViewName} />
        </EgenciaProvider>
    );

    renderArticleList(defaultArticleGroups)
    
    if (!EG.bootstrapped.isTripDetailsPage) {
        uitk.deleteCookie('trips_phone_number');
        uitk.deleteCookie('meetings_customer_care_email');
    }
    function renderArticleList(articleGroups) {
        const articleCount = articleGroups.reduce((sum, num) => { sum += num.articles.length; return sum; }, 0);
        faqsContainer.render(
            <EgenciaProvider>
                <UitkSpacing padding="two">
                    <div>
                        {!anonymousUser && EG.bootstrapped.llmFeatureToggle === true &&
                            // putting LLM card in this component instead of panel-header in order to not pin the card to the top, like regular search
                            <LLMCard/>
                        }
                        {articleCount ? (
                            <>
                                <PanelArticlesList articleGroups={articleGroups}/>
                                {EG.user && (
                                    <UitkSpacing margin={{blockstart: "six"}} padding={{inline: "four"}}>
                                        <VisitHelpCenter />
                                    </UitkSpacing>
                                )}
                            </>
                        ) : (
                            <NoSearchResults />
                        )}
                    </div>
                </UitkSpacing>
            </EgenciaProvider>
        );
    }
};